import { connect } from 'react-redux'
import { compose, branch, renderNothing } from 'recompose'
import component from './component'
import withAgentStatus from 'components/withAgentStatus'
import * as UserSelectors from 'app/modules/user/selectors'

export default compose(
  withAgentStatus,
  branch(({ isAgentStatusLoaded }) => !isAgentStatusLoaded, renderNothing),
  branch(
    ({ renderAgentName }) => renderAgentName,
    connect(state => ({
      displayName: UserSelectors.currentUser(state).name,
    })),
  )
)(component)



// WEBPACK FOOTER //
// ./src/scripts/components/AgentStatusPane/index.js